// extracted by mini-css-extract-plugin
export default {"subTitle":"M8LuHkwreMnULVf43MwHKg=="};